import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi, useAppContext } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { Awesome } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard, ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function CkassaBlacklistScreen() {
    const { t } = useTranslation();
    const params = useParams();
    const header = t("Блэклист ckassa");
    return <DefaultLayout>{params.id ? <Edit header={header} /> : <List header={header} />}</DefaultLayout>;
}

function List({ header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:market:ckassa_blacklist:list"));
    const { setDelData } = useAppContext();

    if (!apiData) return;

    const headerTools = (
        <Link to={url_reverse("market:ckassa_blacklist:edit", { blacklist_id: "add" })} className="btn btn-sm btn-dark">
            <Awesome type="plus-circle" /> {t("Добавить")}
        </Link>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Дата добавления")}</th>
                        <th>Sezam ID</th>
                        <th>{t("Логин")}</th>
                        <th>Steam login</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => {
                        return (
                            <tr key={`object_list${o.id}`}>
                                <td>{o.date_added}</td>
                                <td>{o.user_id}</td>
                                <td>{o.login}</td>
                                <td>{o.steam_login}</td>
                                <td className="dmg-table-row-tools">
                                    <Awesome
                                        type="trash-o"
                                        color="red"
                                        onClick={() =>
                                            setDelData({
                                                url: url_reverse("api:market:ckassa_blacklist:list", null, {
                                                    ids: o.id,
                                                }),
                                            })
                                        }
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Edit({ header }) {
    const { apiData } = useAppApi(url_reverse("api:market:ckassa_blacklist:edit", { blacklist_id: "add" }));

    if (!apiData) return;

    return (
        <CommonCard header={header}>
            <RenderForm backUrl={url_reverse("market:ckassa_blacklist:list")} />
        </CommonCard>
    );
}
